import React, { useState } from "react";


export default function Child ({ sendDataToParent }) {
  const [dataFromChild, setDataFromChild]=useState('');
  
  const handleButtonClick = ()=>{
    sendDataToParent(dataFromChild)
  }

  return(
  <div>
    <input placeholder="Input a name" onChange={(e)=>setDataFromChild(e.target.value)}></input>
    <button onClick={()=>sendDataToParent(dataFromChild)}>SAVE</button>
  </div>
)
}
